import { render } from "./NavMobile.vue?vue&type=template&id=2d8cd548&scoped=true"
import script from "./NavMobile.vue?vue&type=script&lang=js"
export * from "./NavMobile.vue?vue&type=script&lang=js"

import "./NavMobile.vue?vue&type=style&index=0&id=2d8cd548&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8cd548"]])

export default __exports__